import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=d6dc4e56&scoped=true"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dc4e56",
  null
  
)

export default component.exports